import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
import { useCompare, toggleCompare } from '@/lib/productStore';
import { useCategoryLabels } from '@/hooks/useCategoryLabels';

export default function ProductCard({ product, index = 0 }) {
  const compare = useCompare();
  const categoryLabel = useCategoryLabels();
  const isCompared = compare.includes(product.id);
  const onCompareToggle = (e) => { e.preventDefault(); e.stopPropagation(); toggleCompare(product.id); };
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.04 }}
    >
      <Link to={`/shop/${product.custom_slug || product.id}`} className="group block bg-[#111115] hover:bg-[#1a1a1f] transition-colors duration-300 relative overflow-hidden">
        {/* Red top accent */}
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-400 origin-left z-10" />

        {/* Image */}
        <div className="aspect-[4/3] overflow-hidden bg-muted/30 relative flex items-center justify-center p-6">
          {product.image_url ? (
            <img
              src={product.image_url}
              alt={product.name}
              className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-white/10 text-xs">NO IMAGE</span>
            </div>
          )}
          {(product.in_stock === false || (product.stock_quantity !== null && product.stock_quantity !== undefined && product.stock_quantity <= 0)) && (
            <div className="absolute top-3 left-3 bg-black/70 text-white/50 text-[10px] font-bold tracking-wider px-2 py-1">
              OUT OF STOCK
            </div>
          )}
          {product.stock_quantity !== null && product.stock_quantity !== undefined && product.stock_quantity > 0 && product.stock_quantity <= 3 && (
            <div className="absolute top-3 right-3 bg-yellow-500/20 text-yellow-400 text-[10px] font-bold tracking-wider px-2 py-1">
              {product.stock_quantity} LEFT
            </div>
          )}
          <button
            type="button"
            onClick={onCompareToggle}
            title={isCompared ? 'Remove from compare' : 'Add to compare'}
            className={`absolute bottom-3 right-3 z-10 inline-flex items-center gap-1 text-[9px] font-bold tracking-widest px-2 py-1 border transition-colors ${isCompared ? 'border-primary bg-primary text-white' : 'border-white/15 bg-black/60 text-white/60 hover:text-white hover:border-white/40'}`}
          >
            <Scale className="w-3 h-3" /> {isCompared ? 'COMPARING' : 'COMPARE'}
          </button>
        </div>

        {/* Info */}
        <div className="p-6">
          <p className="text-primary text-[10px] font-bold tracking-widest mb-2 uppercase">
            {categoryLabel(product.category)}
          </p>
          <h3 className="text-white font-bold text-base leading-snug mb-4 line-clamp-2 group-hover:text-primary transition-colors">
            {product.name}
          </h3>
          <p className="text-white font-black text-xl">
            £{product.price?.toFixed(2)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
}